















import { Component, Vue, Prop } from 'vue-property-decorator';

export enum MainTitleSize {
  Large = 'large',
  Medium = 'medium',
  small = 'small',
}

export enum MainTitleItemType {
  Normal = 'normal',
  Highlight = 'highlight',
}

export interface MainTitleItem {
  type: MainTitleItemType;
  value: string;
}
@Component({
  components: {},
})
export default class MainTitle extends Vue {
  @Prop()
  items!: MainTitleItem[];

  @Prop()
  size!: MainTitleSize;

  @Prop({ default: true })
  withFullStop!: boolean;

  get isFistHightlight() {
    const firstItem = this.items[0];

    if (firstItem && firstItem.type === MainTitleItemType.Highlight) {
      return true;
    } else {
      return false;
    }
  }

  get isLastHighlight() {
    const lastItem = this.items.slice(-1)[0];

    if (lastItem && lastItem.type === MainTitleItemType.Highlight) {
      return true;
    } else {
      return false;
    }
  }

  get mainClass() {
    let mainClass = 'text-lg sm:text-36 font-bold mb-0 leading-snug';

    if (this.size === MainTitleSize.Medium) {
      mainClass = 'text-md sm:text-24 font-bold mb-0 leading-snug';
    } else if (this.size === MainTitleSize.small) {
      mainClass = 'text-16 sm:text-18 font-medium mb-0 leading-snug';
    }

    return mainClass;
  }

  get highlightClass() {
    let spanClass = 'px-2vw mx-2vw sm:px-10 sm:mx-10';

    if (this.isFistHightlight) {
      spanClass = 'px-1vw mr-1vw sm:px-6 sm:mr-6';
    }

    if (this.size === MainTitleSize.Medium) {
      spanClass = 'px-1vw mx-1vw sm:px-6 sm:mx-6';

      if (this.isFistHightlight) {
        spanClass = 'px-1vw mr-1vw sm:px-6 sm:mr-6';
      }
    }

    if (this.size === MainTitleSize.small) {
      if (this.isFistHightlight) {
        spanClass = 'px-2 mr-2 sm:px-3 sm:mr-3';
      } else if (this.isLastHighlight) {
        spanClass = 'pl-2 ml-2 sm:pl-3 sm:ml-3';
      } else {
        spanClass = 'px-2 mx-2 sm:px-3 sm:mx-3';
      }
    }

    return spanClass + ' text-red-100 bg-red-300 rounded-DEFAULT';
  }
}
